<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<div class="container-fluid mt-0">
  <p-confirmDialog class="confirm-message" appendTo="body"></p-confirmDialog>
  <p-confirmDialog key="warning" appendTo="body"></p-confirmDialog>
  <div class="row">
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class="row m-0 p-0">
          <div class="col-11" id="multiselectDiv">
            <div class="ui-inputgroup mb-0" id="filterLabel">
              <button pButton class="theme-button noHover labelButton" type="button" label="Filter"></button>
              <p-multiSelect [options]="filterOptions" (onChange)="onApplyFilter()" [(ngModel)]="selectedStatuses" optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
                id="multiselectStatuses" placeholder="Sel. Status" [maxSelectedLabels]="1" styleClass="multiSelectionDropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span style="vertical-align:middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
          </div>

          <div class="col-1" id="refreshBatchesDiv">
            <button pButton class="refreshBatches" *ngIf="checkQCScan()" icon="fa fa-refresh" (click)="onApplyFilter()"></button>
          </div>
        </div>
        <div class="row m-0 p-0">
          <div class="col-11 pt-2" id="multiselectDiv">
            <div class="ui-inputgroup mb-0" id="filterLabel">
              <button pButton class="theme-button noHover labelButton" type="button" label="Protocol"></button>
              <p-multiSelect [options]="processFlowsList" name="processFlowsList" (onChange)="onApplyFilter()" [(ngModel)]="selectedProcessFlowList" optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
                id="multiselectStatuses" placeholder="Sel. Protocol" [maxSelectedLabels]="1" styleClass="multiSelectionDropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span style="vertical-align:middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
          </div>

          <div class="col-1 pt-2" id="refreshBatchesDiv">
            <button pButton class="refreshBatches resetButton" icon="pi pi-times" (click)="resetAllFilter()"></button>
          </div>
        </div>
        <div class="row m-0 p-0">
          <div class="col-11 pt-2" id="multiselectDiv">
            <div class="ui-inputgroup">
              <button pButton class="theme-button noHover labelButton" type="button" label="Date"></button>
              <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
                dateFormat="dd.mm.yy" [showIcon]="true" placeholder="Sel. Start Date" showButtonBar="true"
                (onClearClick)="onApplyFilter()" (onTodayClick)="onApplyFilter()">
              </p-calendar>
            </div>
          </div>
          <div class="col-1 pt-2"></div>
          <div class="flex justify-content-between px-0">
            <span class="m-0 col-7 px-0">Number Of Plates Matching Filter:
              <span class="m-0 font-weight-bold text-success" style="font-size: 1.2rem;">{{plates == null ? 0: plates.length}}</span>
            </span>
            <span class="col-4 m-0 px-0">Show Due Date <p-inputSwitch [(ngModel)]="showDueDate"></p-inputSwitch></span>
          </div>
        </div>

      </div>
      <div class="col-9">
        <div class="col-12 flex" id="topGroup">

          <div class="col-4 topDivspacing pr-0" id="topDiv">
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="User ID"></button>
              <input pInputText name="UserPUID" [value]="puid" size="10" id="userID" class="inputFileds" readonly/>
            </div>
            <div class="ui-inputgroup" id="inputClass" value="enabeledd">
              <button pButton class="theme-button noHover labelButton" type="button" label="Plate ID"></button>
              <input pInputText name="SearchPlate" [(ngModel)]="plateToSearch" size="10"
                (keydown.enter)="searchForPlate()" class="inputFileds"/>
              <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForPlate()"></button>
            </div>
            <div class="ui-inputgroup" id="inputClass" value="enabeledd">
              <button pButton class="theme-button noHover labelButton" type="button" label="Sample ID"></button>
              <input pInputText name="SearchSample" [(ngModel)]="sampleToSearch" size="10"
                (keydown.enter)="searchForSample()" class="inputFileds"/>
              <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForSample()"></button>
            </div>
          </div>

          <div class="col-5 topDivspacing pl-0 pr-0" style="text-align:left;">
            <div class="col-12 flex headers">
              <h5>
                Plate: <strong>{{selectedPlate?.lastUpdatedPlateID}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers statusField" id="headerNonTop">
              <h5>
                Status: <strong> {{selectedPlate?.status}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers" id="headerNonTop">
              <h5>
                Sample Type: <strong> {{selectedPlate?.sampleType}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers" *ngIf="selectedPlate?.storagePlate">
              <h5>
                Storage: <strong> {{selectedPlate?.storage}} </strong>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class="tableLHS1">
          <p-table [value]="plates" selectionMode="single" (onRowUnselect)="removePlateSelection()"
            (onRowSelect)="showPlateInfo($event)" [loading]="loading"
            [(selection)]="tableSelectedRow">
            <ng-template pTemplate="header">
              <tr style="border: 1px solid lightgray">
                <th scope="col" style="width: 35%; border: 1px solid lightgray">Plate ID <span *ngIf="showDueDate"><br/> (Due Date) </span></th>
                <th scope="col" style="width: 65%; border: 1px solid lightgray">Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-plate>
              <tr style="border: 1px solid lightgray" [pSelectableRow]="plate" >
                <td style="width: 35%;border: 1px solid lightgray" [ngClass]="getPriorityClass(plate?.priority)" class="normalBody text-break pr-0">
                    <span>{{plate?.lastUpdatedPlateID}}</span>
                    <i *ngIf="plate?.latestUserComment" class="pi pi-comment p-1" [pTooltip]="showLatestComment(plate,datePipe)"></i>
                    <i class="pi pi-star-fill" *ngIf="plate?.reRun"></i>
                    <i class="pi pi-arrow-right-arrow-left p-1" *ngIf="checkStatusChange(plate)"></i>
                  <span *ngIf="showDueDate"><br/> ({{ convertUtcToLocal(plate.dueDate) | date : 'dd.MM.yyyy' }}) </span>
                </td>
                <td style="width: 65%;border: 1px solid lightgray" [ngClass]="getPriorityClass(plate?.priority)" class="normalBody pr-0">
                  {{plate?.status}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <app-ma-comments-popup [qcScan]="qcScan" [selectedPlateID]="selectedPlateID" [selectedPlateStatus]="selectedPlateStatus"  [plateCommentList] = "plateCommentsList"  [beadChipCommentsDisplayMap]="beadChipCommentsDisplayMap" [beadChipCommentsMap]="beadChipCommentsMap" (backButtonEmitter)="hideDialog($event)"></app-ma-comments-popup>
      </div>
      <div class="col-9">
        <div class="col-12 flex" id="tableDiv">
          <p-confirmDialog class="confirm-message"></p-confirmDialog>
          <table id="batchTable" class="rightTable" aria-describedby="Unboxing Table">
            <thead id="batchTableHeader">
              <tr>
                <th scope="col">QC Scan</th>
              </tr>
            </thead>
            <tbody id="batchTableBody">
              <p-header>
                <div class="row m-1" style="padding: 0.5% 3%;">
                  <div class="col-2 p-0">
                    <button pButton label="Start QC Scan" class="buttonsRound startButton" (click)="startQCScan()" (keydown.enter)="startQCScan()"
                      [disabled]="disableStartQCScanButton()">
                    </button>
                  </div>
                  <div class="col-4">
                    <input type="text" class="sample-pos" [value]="getSelectedCell()" readonly>
                    <input type="password" class="scan-barcode" id="barcode-scanner" placeholder="Scan Barcode"
                    [(ngModel)]="scannedBarcode" (keydown.enter)="saveBarcode()" [disabled]="disableScanBarcodeInput()">
                  </div>
                  <div class="col-4" style="display:flex; flex-direction:column">
                    <p style="margin:0%;margin-top:-4%">Previously scanned:</p>
                    <input type="text" class="scanned-barcode" [value]="previousScannedBarcode" style="width:50%" disabled readonly>
                  </div>

                  <div class="col-2" >
                    <p-fileUpload #fileUploaderInternal [style]="getFileUploadStyle()" id="fileUpload" (onSelect)="onInternalFileSelect($event)" (uploadHandler)="validateSamples($event, fileUploaderInternal)" mode="basic"
                    customUpload="true" accept=".xls" chooseLabel="Upload Excel"  [disabled]="disableScanBarcodeInput()" auto="true"></p-fileUpload>
                  </div>

                </div>
              </p-header>
              <p-header>
                <div class="row m-1" style="padding: 0.5% 3%;">
                  <div class="col-1 p-0">
                    <h5 class="legend">Legend</h5>
                  </div>
                  <div class="col-6">
                    <button pButton label="Match" class="green-legend" readonly></button>
                    <button pButton label="Switch" class="orange-legend" readonly></button>
                    <button pButton label="NotExisting" class="red-legend" readonly></button>
                  </div>
                </div>
              </p-header>
              <table id="scanTable" aria-describedby="View Plates" class="table">
                <thead>
                  <tr class="row100 head">
                    <th class="column100 column1" scope="col"></th>
                    <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders; let k = index">
                      {{col}} </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
                    <td class="column100 column1">{{row}}</td>
                    <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index"
                      style="padding:0% 0.15rem;">
                      <input [style.background] = "getSampleAt(i, j).color" class="cellviewsold selected-cell" *ngIf="checkSelectedCell(i,j)" pInputText type="text" (click)="selectTableCell(i,j)"
                        [value]="getSampleAt(i, j).sampleID" [pTooltip]="getSampleAt(i, j).sampleID" tooltipPosition="top" readonly />
                      <input [style.background] = "getSampleAt(i, j).color" class="cellviewsold" *ngIf="!checkSelectedCell(i,j)" pInputText type="text" (click)="selectTableCell(i,j)"
                        [value]="getSampleAt(i, j).sampleID" [pTooltip]="getSampleAt(i, j).sampleID" tooltipPosition="top" readonly />
                    </td>
                  </tr>
                </tbody>

              </table>
              <p-footer>
                <div class="row m-0" style="padding: 0% 3%;">
                  <div class="col-5 p-0" style="display:flex;">
                    <button pButton label="Storage" [disabled]="disableStorageButton()" class="buttonsRound otherbutton" (click)="showStorageDialog()"></button>
                    <button pButton class="buttonsRound otherbutton" label="Remove Sample(s)" (click)="removeSamplesPopup()" [disabled]="disableScanCompleteButton()" style="margin-left: auto;"></button>
                  </div>
                  <div class="col-2"></div>
                  <div class="col-5 p-0" style="display:flex;">
                    <button pButton label="Save Plate" class="buttonsRound startButton" (click)="savePlate()" style="margin-left: auto;" [disabled]="disableSavePlateButton()"></button>
                    <button pButton class="buttonsRound thirdButton" label="Complete QC Scan" (click)="completeQCScan()" style="margin-left: auto;" [disabled]="disableCompleteQCScanButton()"></button>
                  </div>
                </div>
              </p-footer>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog  header="Wrong Sample Position!" [(visible)]="showSampleMismatchDialog" [modal]="true" position="top" (onHide)="clearPopUpFields()">
  <div [style]="{height: '70%'}">
    <br/>
    <h5>This Sample <span class="fontColor"><b>{{scannedBarcode}}</b></span> was scanned on wrong Position</h5>
    <h5> Do you want to keep it there in the Scanned Position <span style="background-color: yellow;"><b>{{selectedCell}}</b></span>
      or do you want to switch it with the original position  <span style="background-color: orange;"><b>{{sample.position}}</b></span> ?</h5>
    <div>
    <table id="scanTable1" aria-describedby="View Plates" style="margin-left: 5rem;">
      <thead>
        <tr class="row100">
          <th class="column100" scope="col"></th>
          <th class="column100" scope="col" *ngFor="let col of columnHeaders; let k = index">
            {{col}} </th>
        </tr>
      </thead>
      <tbody>
        <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
          <td class="column100" >{{row}}</td>
          <td class="column100" *ngFor="let col of columnHeaders; let j = index"
            style="padding:0% 0.15rem;">
            <input class="cellviewsold1 scanned-cell" *ngIf="checkScannedPosition(i,j)" pInputText type="text"
              readonly />
            <input  class="cellviewsold1 scanned-cell1" *ngIf="checkReceptionPosition(i,j)" pInputText type="text"
              readonly />
              <input  class="cellviewsold1" *ngIf="!checkReceptionPosition(i,j)&&!checkScannedPosition(i,j)" pInputText type="text"
              readonly />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </div>
  <br>
  <div class="popupAlignment">
  <div class="ui-inputgroup" id="inputClass">
    <button pButton class="theme-button noHover labelButton" type="button" label="Top Barcode"></button>
    <input pInputText name="SearchPlate" [(ngModel)]="topBarcode" size="5" class="inputFileds" (keydown.enter)="findAndHighlightElement('bottomBarcode')"/>
  </div>
  <div class="ui-inputgroup" id="inputClass">
    <button pButton class="theme-button noHover labelButton" type="button" label="Bottom Barcode"></button>
    <input pInputText name="SearchPlate" id="bottomBarcode" [(ngModel)]="bottomBarcode" size="5" class="inputFileds"/>
  </div>
</div>
  <div class="col-12 flex mt-2 add-comment-container">
    <button pButton label="Continue" id="add-comment" (click)="closeTopAndBottomBarcodePopup()" [disabled]="disableContinueButton()"></button>
  </div>
</p-dialog>


<p-dialog header="Barcode Not Present" [(visible)]="showSampleCheckFailedDialog" [modal]="true" position="top" (onHide)="clearPopUpFields()">
  <div class="col-12">
    <br/>
    <div *ngIf="!showReceptionBarcode">
      <h5> The Sample <span class="fontColor"><b>{{getReceptionBarcodeByColor()}}</b></span> was scanned in Reception</h5>
    </div>
    <div *ngIf="showReceptionBarcode">
      <h5> The Sample was <b>Replaced</b></h5>
    </div>
    <h5>  The Sample <span class ="fontColor"><b>{{getQCScanBarcodeByColor()}}</b></span> was scanned in QC-Scan</h5>
    <br/>
    <div class="ui-inputgroup" id="inputClass">
      <button pButton class="theme-button noHover labelButton" type="button" label="Top Barcode"></button>
      <input pInputText name="SearchPlate" [(ngModel)]="topBarcode" size="5" class="inputFileds" (keydown.enter)="findAndHighlightElement('bottom-barcode')"/>
    </div>
    <div class="ui-inputgroup" id="inputClass">
      <button pButton class="theme-button noHover labelButton" type="button" label="Bottom Barcode"></button>
      <input pInputText name="SearchPlate" id="bottom-barcode" [(ngModel)]="bottomBarcode" size="5" class="inputFileds"/>
    </div>
  </div>
  <div class="col-12 flex mt-2 add-comment-container">
    <button pButton label="Continue" id="add-comment" (click)="closeTopAndBottomBarcodePopup()" [disabled]="disableContinueButton()"></button>
  </div>
</p-dialog>

<p-dialog header="Remove sample(s)" [style.width]="'350px'"  [(visible)]="removeSamples" [modal]="true" position="top">
  <div class="col-12">
    <table id="scanTable" aria-describedby="View Plates" class="table">
        <tr>
        <th style="display: none"></th>
        </tr>
        <tr>
          <input class="inputWidth" pInputText placeholder="Enter SampleID" name="sampleId" [(ngModel)]="enteredSampleId" id="popup-sampleid" (keydown.enter)="checkSample()"/>
        </tr>
        <tr *ngFor="let sample of sampleList; let myIndex=index;">
          <input pInputText class="inputWidth" name="sampleId" [value]="sample" id="sampleid" readonly />
          <button pButton icon="fa fa-times-circle"class="removePopInput deleteButtonWidth" (click)="deleteValue(myIndex)"></button>
        </tr>
    </table>
    <div>
      <button [disabled]="disableRemoveSamplesButton()" pButton class="removePopInput removebutton" label="Remove Sample(s)" (click)="deleteSamples()"></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="This is a new Sample" [(visible)]="moveOrReplacePopup" [modal]="true" position="top">
  <div class="col-12">
    <br/>
    <h5>Should it be replaced in the current sample position <span style="color: #1F89CE;">{{selectedCell}}</span> or move the positions of remaining Samples?</h5>
    <br/>
  </div>
  <div class="col-12 flex">
    <div class="col-6 mt-2 add-comment-container">
      <button pButton class="buttonsRound removebutton replaceButton" label="Replace" (click)="replaceAnnouncedBarcode()"></button>
    </div>
      <div class="col-6 mt-2">
      <button pButton class="buttonsRound startButton" label="Move" (click)="moveReceptionBarcodes()"></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Sample Check Failed!" [(visible)]="showSampleAsidePouUp" [modal]="true" position="top">
  <div class="col-12 sample-check-content">
    <br/>
    <h5> Sample Check failed! </h5>
    <br/>
    <h5> {{ sampleCheckErrorMessage }} </h5>
    <br/>
    <h5> Please set the sample aside. </h5>
    <br/>
  </div>
  <div class="col-12 flex mt-2 add-comment-container">
    <button pButton label="Continue" id="add-comment" (click)="closeShowSampleAsidePouUp()"></button>
  </div>
</p-dialog>

<p-dialog header="Sample Check Failed!" [(visible)]="showSampleNotPresentDialog" [modal]="true" position="top">
  <div class="col-12 sample-check-content">
    <br/>
    <h5> Sample Check failed! </h5>
    <br/>
    <h5> {{ sampleCheckErrorMessage }} </h5>
    <br/>
    <h5> Please set the sample aside. </h5>
    <br/>
  </div>
  <div class="col-12 flex mt-2 add-comment-container">
    <button pButton label="Continue" id="add-comment" (click)="closeShowSampleNotPresentDialog()"></button>
  </div>
</p-dialog>

<p-dialog header="Select the Storage Location!" [(visible)]="showStoreDialog" [modal]="true" position="top">
  <div style="width: 28rem;">
    <br/>
    <h5> Select the Storage Location to store the Plate! </h5>
    <br/>
    <div class="ui-inputgroup" style="margin-bottom: 1em !important;">
      <button pButton class="theme-button noHover storageTypeBtn" style="width: 11rem !important; height: 50px !important; border-radius: 5px;" type="button" label="Storage Location"></button>
      <p-dropdown [options]="storageList" filter="true" appendTo="body" [(ngModel)]="selectedStorageLocation" optionLabel="storageName" optionValue="storageName" placeholder="Storage Location" [style]="{'width': '17rem'}">
      </p-dropdown>
    </div>
    <br/>
    <br/>
  </div>
  <div class="col-12 flex mt-2 add-comment-container">
    <button pButton label="Store" id="add-comment"  (click)="saveToStorage()"></button>
  </div>
</p-dialog>

  <p-dialog header="Please select a sample" showEffect="fade" position="top"
    [(visible)]="duplicateSamplesPresent" [modal]="true" [style.width]="'850px'" [contentStyle]="{'max-height':'70vh','overflow-y':'auto'}">
    <div class="content-in-multi-update-popup">
      <table id="scanTable" aria-describedby="View samples" class="table">
        <tbody>
          <tr>
            <th>Sample ID</th>
            <th>SampleType</th>
            <th>Activated</th>
            <th>Gender</th>
            <th>Announced</th>
            <th>Unsuitable (Reason)</th>
            <th>Completed (Date)</th>
            <th></th>
          </tr>
          <tr *ngFor="let sample of sampleData; let i=index">
            <td>{{ !sample.animalNumber? sample.barCode : sample.animalNumber }}</td>
            <td>{{sample.sampleType}}</td>
            <td>{{sample.activated? "Yes" : "No"}}</td>
            <td>{{sample.gender}}</td>
            <td>{{sample.announcedDate | date: 'dd.MM.yy'}}</td>
            <td>{{sample.receptionStatus === 'REMOVED' ? "Yes (" + sample.receptionIssueReason + ")" : "No" }}</td>
            <td>{{sample.sampleCompletionDate !== null ? ("Yes (" + (sample.sampleCompletionDate | date: 'dd.MM.yy') + ")") : "No"}}</td>
            <td>
              <button [disabled]="checkIfSampleIsDisabledForSelection(sample)"
                class="removeMargin buttonsRound endButton ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
                (click)="selectedSampleFromScan(sample)">Select Sample</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </p-dialog>

  <p-dialog [(visible)]="showQcScanNotCompletedPopup" [modal]="true" position="top"
  [style]="{width: '50vw'}">
    <p-header class="boldFont">
      QC Scan Not Completed!!
    </p-header>
    <div class="col-9">
      <br />
      <h5><b>Not all samples have gotten a scan for QC-Check.</b></h5>
      <br />
      <h5>Do you want to continue?</h5>
      <br />
    </div>
    <div  class="col-12 flex">
      <div class="col-6 mt-2 add-comment-container">
        <button pButton class="buttonsRound removebutton goBackButton" label="Go Back" (click)="goBackCompleteScan()"></button>
      </div>
      <div class="col-6 mt-2">
        <button pButton class="buttonsRound startButton" label="Continue" (click)="updateQCPlate()"></button>
      </div>
  </div>
  </p-dialog>
